import {
  ATTRS_ANALYTICS_FUNNEL_LOCALE,
  ATTRS_ANALYTICS_FUNNEL_NAME,
} from 'core/common/observability/entities';
import { ObservabilitySystem } from 'core/common/observability/interfaces';
import { ErrorMonitoring } from 'core/common/services/errorMonitoring';
import { FunnelSettingsServiceInterface } from 'core/common/services/funnel-settings/interfaces';
import { BingAdsService } from '../../interfaces';
import { BingAdsServiceWithMonitoring } from './BingAdsServiceWithMonitoring';

export class BingAdsServiceBuilder {
  constructor(private bingAdsService: BingAdsService) {}

  addMonitoring(
    observabilitySystem: ObservabilitySystem,
    errorMonitoringService: ErrorMonitoring,
    funnelSettingsService: FunnelSettingsServiceInterface,
  ): this {
    const provideAdditionalObservabilityAttributes = () => {
      return {
        [ATTRS_ANALYTICS_FUNNEL_NAME]: funnelSettingsService.getFunnelName(),
        [ATTRS_ANALYTICS_FUNNEL_LOCALE]: funnelSettingsService.getFunnelLocale(),
      };
    };

    this.bingAdsService = new BingAdsServiceWithMonitoring(
      this.bingAdsService,
      observabilitySystem,
      errorMonitoringService,
      provideAdditionalObservabilityAttributes,
    );

    return this;
  }

  getResult(): BingAdsService {
    return this.bingAdsService;
  }
}
